"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.c = classesToSelector;
function classesToSelector(e) {
  return void 0 === e && (e = ""), ".".concat(e.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, "."));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIjAiXSwibmFtZXMiOlsiY2xhc3Nlc1RvU2VsZWN0b3IiLCJjbGFzc2VzIiwidHJpbSIsInJlcGxhY2UiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLFNBQVNBLGlCQUFBQSxDQUFrQkMsQ0FBQUEsRUFBQUE7RUFJekIsT0FBQSxLQUhnQixDQUFBLEtBQVpBLENBQUFBLEtBQ0ZBLENBQUFBLEdBQVUsRUFBQSxDQUFBLE1BQUEsTUFBQSxDQUVEQSxDQUFBQSxDQUFRQyxJQUFBQSxDQUFBQSxDQUFBQSxDQUFPQyxPQUFBQSxDQUFRLGNBQUEsRUFBZ0IsTUFBQSxDQUFBLENBQ2pEQSxPQUFBQSxDQUFRLElBQUEsRUFBTSxHQUFBLENBQUEsQ0FDakI7QUFBQSJ9